import { render, staticRenderFns } from "./WebstoreApiTokenNew.vue?vue&type=template&id=2e525486&scoped=true&"
import script from "./WebstoreApiTokenNew.vue?vue&type=script&lang=ts&"
export * from "./WebstoreApiTokenNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e525486",
  null
  
)

export default component.exports